<template>
  <footer class="footer">
    <div class="container">
      <nav>
        <ul>
          <li>
            <a href="#/releasenotes">Version 0.1.51</a>
          </li>
          <li>
            <a href="#">
              Terms of Use
            </a>
          </li>
          <li>
            <a href="#">
              Privacy Policy
            </a>
          </li>
          <li>
            <a href="#">
              License
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        &copy; {{ new Date().getFullYear() }} Fortis Payments
      </div>
    </div>
  </footer>
</template>
<script>
export default {};
</script>
<style></style>
